var map = {
	"./account.svg": "345a",
	"./add-new-buyer-success.svg": "6cb0",
	"./add-white.svg": "8515",
	"./arrow-down.svg": "d049",
	"./back.svg": "36ca",
	"./caps.svg": "9398",
	"./config.svg": "8306",
	"./contract.svg": "f2606",
	"./dashboard.svg": "187e",
	"./delete.svg": "455c",
	"./example.svg": "ad13",
	"./finance.svg": "bd33",
	"./fund.svg": "365c",
	"./home-vol.svg": "2671",
	"./notice.svg": "5729",
	"./org.svg": "877c",
	"./search.svg": "2e1e",
	"./sum.svg": "f578",
	"./upload.svg": "cfc5",
	"./vol.svg": "702f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d4e";